import WaitComponent from "./Wait.vue"
import {
    EventBus
} from "./waitEventBus"

const defaultOptions = {
    version: 1,
    background: 'primary'
};

const WaitPlugin = {
    install(Vue, options) {

        // Merge  opzioni default con arg options
        let userOptions = { ...defaultOptions, ...options };

        // Registro il componente
        Vue.component('wait', WaitComponent)

        // Memorizzo le opzioni
        Vue.prototype.$waitOptions = userOptions

        Vue.prototype.$wait = {

            open() {
                EventBus.$emit('WaitOpen', 'open')
            },

            close() {
                EventBus.$emit('WaitOpen', 'close')
            },
        }

    }
}

export default WaitPlugin
